module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step6.f08217c5.png";